import FetchApi from "./api";
import config from "../config";

const serviceProfile = {
	getProfile: () =>
		FetchApi(`${config.urls.apiBaseUrl}api/Profile/GetProfile`, "GET"),
	createProfile: (payload) =>
		FetchApi(
			`${config.urls.apiBaseUrl}api/Profile/CreateProfile`,
			"POST",
			payload
		),
	updateProfile: (payload) =>
		FetchApi(
			`${config.urls.apiBaseUrl}api/Profile/UpdateProfile`,
			"PUT",
			payload
		),
	deleteAccount: () =>
		FetchApi(
			`${config.urls.apiBaseUrl}api/Account/DeleteAccount`,
			"DELETE"
		),
};

export default serviceProfile;
